import { Controller } from "@hotwired/stimulus"
import { initPostHog } from "../posthog"

export default class extends Controller {
  connect() {
    if (localStorage.getItem("cookie_consent") === "accepted") {
      this.element.remove()
    } else {
      this.element.classList.remove("hidden")
    }
  }

  accept() {
    localStorage.setItem("cookie_consent", "accepted")
    this.element.remove()
    // Initialize PostHog after consent is given
    initPostHog()
  }
}
